module.exports = __webpack_public_path__ + "img/bottomLine.49bdedd1.png";